import { FC } from 'react';
import Image, { ImageProps } from 'next/image';
import MuiBox from "@new-components/atoms/MuiBox";
import MuiTypography from "@new-components/atoms/MuiTypography";
import { Icon } from './icon';
import { OffersCardStyles } from './styles';

export interface OfferCardProps {
    image: ImageProps;
    category: string;
    title: string;
    expiresIn: string;
}

const OfferCard: FC<OfferCardProps> = (props) => {
    return (
        <MuiBox sx={OffersCardStyles.cardWrapper}>
            <MuiBox sx={OffersCardStyles.cardLeft}>
                <MuiBox sx={OffersCardStyles.cardImage}>
                    <Image
                        src={props.image.src}
                        alt={props.image.alt}
                        fill
                        sizes='(max-width: 600px) 68px, 96px'
                        style={{objectFit: 'cover'}}
                    />
                </MuiBox>
            </MuiBox>
            <MuiBox sx={OffersCardStyles.divider} />
            <MuiBox sx={OffersCardStyles.cardRight}>
                <MuiTypography sx={OffersCardStyles.category}>
                    {props.category}
                </MuiTypography>
                <MuiTypography title={props.title} sx={OffersCardStyles.title}>
                    {props.title}
                </MuiTypography>
                <MuiBox sx={OffersCardStyles.expiryWrapper}>
                    <Icon />
                    <MuiTypography sx={[OffersCardStyles.category, OffersCardStyles.expiry]}>
                        Expires in {props.expiresIn}
                    </MuiTypography>
                </MuiBox>
            </MuiBox>
        </MuiBox>
    )
}

export default OfferCard